import React from 'react';
import { IGetReportingResponse } from '../../../interfaces/api/IEmails';

export default function TableBodyReporting({data} : { data: IGetReportingResponse}) {
    return (
        <tbody>
            {data.store_details.length === 0 && (
                <tr>
                    <td colSpan={6} className="no-results">Aucun résultat</td>
                </tr>
            )}
            {data.store_details.length > 0 &&
            (
                <>
                    {storeRaw(data)}
                </>
            )}
        </tbody>
    );
}


function storeRaw(data: IGetReportingResponse) {
    return data.store_details.map((store, indexStore) => {
        return store.total_by_date.map((dateValue, indexValue) => {
            return (
                <>
                    {indexValue === 0 && (
                        <tr className="store" key={indexStore+"-"+indexValue}>
                            <td className="store key" rowSpan={store.total_by_date.length}>{store.name} - {store.code}</td>
                            <td className="date">{dateValue.date}</td>
                            <td className="stat sent">{dateValue.mail_sent_quantity}</td>
                        </tr>
                    )}
                    {indexValue !== 0 && (
                        <tr key={indexStore+"-"+indexValue}>
                            <td className="date">{dateValue.date}</td>
                            <td className="stat sent">{dateValue.mail_sent_quantity}</td>
                        </tr>
                    )}
                </>
            );
        });
    });
}